import { Component, h, Host, Prop } from "@stencil/core";

/**
 * @slot title - Slot for the product title (`<h3>` or `<h2>`)
 * @slot subtitle - Slot for the product subtitle (`<p>` or `<div>`)
 * @slot image - Slot for the product image (`<picture>` with 3:2 aspect ratio)
 * @slot description - Slot for the product description (`<p>` or `<div>`)
 * @slot usp - Slot for the list with product usps (`<ul>`)
 * @slot cta - call to action (`<ux-button>`)
 */
@Component({
    tag: "ux-iws-nb-teaser-product",
    styleUrl: "nb-teaser-product.scss",
})
export class NbTeaserProduct {
    /** Comma separated list of tags */
    @Prop() tags: string = "";
    /** Comma separated list of tags that are supported */
    @Prop() supportedTags: string = "";
    /** Comma separated list of tags that are highlighted */
    @Prop() highlightedTags: string = "";

    render() {
        const baseClass = "ux-iws-nb-teaser-product";
        const allTags = this.tags.split(",").map((tag) => tag.trim());
        const supportedTags = this.supportedTags
            .split(",")
            .map((tag) => tag.trim());
        const highlightedTags = this.highlightedTags
            .split(",")
            .map((tag) => tag.trim());
        return (
            <Host class={baseClass}>
                <div class={`${baseClass}__grid`}>
                    <div class={`${baseClass}__image`}>
                        <slot name="image" />
                    </div>
                    <div class={`${baseClass}__header`}>
                        <slot name="title" />
                        <slot name="subtitle" />
                    </div>
                    <div class={`${baseClass}__tags`}>
                        {allTags.map((tag) => (
                            <span
                                class={{
                                    [`${baseClass}__tag`]: true,
                                    [`${baseClass}__tag--supported`]:
                                        supportedTags.includes(tag),
                                    [`${baseClass}__tag--unsupported`]:
                                        !supportedTags.includes(tag),
                                    [`${baseClass}__tag--highlighted`]:
                                        supportedTags.includes(tag) &&
                                        highlightedTags.includes(tag),
                                }}
                                key={tag}
                            >
                                {tag}
                            </span>
                        ))}
                    </div>
                    <div class={`${baseClass}__description`}>
                        <slot name="description" />
                    </div>
                    <div class={`${baseClass}__usp`}>
                        <slot name="usp" />
                    </div>
                    <div class={`${baseClass}__cta`}>
                        <slot name="cta" />
                    </div>
                </div>
            </Host>
        );
    }
}
